import React from 'react';
import { Link } from 'react-router-dom';

const ServiceCard = ({ 
  icon, 
  title, 
  description, 
  buttonText, 
  buttonLink, 
  buttonAction 
}) => {
  return (
    <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all transform hover:-translate-y-2 border border-orange-100">
      <div className="text-center">
        <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
          {icon}
        </div>
        <h3 className="text-xl font-bold text-orange-800 mb-3">{title}</h3>
        <p className="text-gray-600 mb-4">{description}</p>
        {buttonLink ? (
          <Link 
            to={buttonLink} 
            className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-full font-semibold hover:from-orange-600 hover:to-red-600 transition-all inline-block"
          >
            {buttonText}
          </Link>
        ) : (
          <button 
            onClick={buttonAction}
            className="bg-gradient-to-r from-orange-500 to-red-500 text-white px-6 py-2 rounded-full font-semibold hover:from-orange-600 hover:to-red-600 transition-all"
          >
            {buttonText}
          </button>
        )}
      </div>
    </div>
  );
};

export default ServiceCard;
